import { React, useEffect, useState, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  DownArrowDraw,
  DropDownSearchDraw,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Checkbox,
  Radio,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import "antd-country-phone-input/dist/index.css";
import "flagpack/dist/flagpack.css";
import { useLocation, useNavigate } from "react-router";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { GlobalSet, Styled } from "../../pageStyled";
import warning from "../../../Assets/Icons/warning.png";
import {
  getJobCardSerialNumberParam,
  updateOrderCreationConfig,
} from "../../../Services/settingsServices";
import OrderCreationConfigSettingDrawer from "./OrderCreationConfigSettingDrawer";

const toggleOptions = [
  { label: "Product name", value: "name" },
  { label: "Product spec", value: "specs" },
];

const OrderCreationConfig = (props) => {
  const history = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const [ordersOption, setOrdersOption] = useState();
  const [uploading_ordersOption, setUploadingOrdersOption] = useState();
  const [fetchingOrdersFromERP_option, setFetchingOrdersFromERPOption] =
    useState();
  const [dummy_ordersOption, setDummyOrdersOption] = useState();
  const [data, setData] = useState();
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [categoryType, setCategoryType] = useState();
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [isVisibleOrderCreationConfigDrawer, setVisibleOrderCreationConfigDrawer] = useState(false);
  const [isDataUpdated,setDataUpdated] = useState(false);

  useEffect(async () => {
    const settingsData = await getJobCardSerialNumberParam();
    if (settingsData) {
      setOrdersOption(
        settingsData?.data?.order_creation_config?.orders?.product_selection
      );
      setUploadingOrdersOption(
        settingsData?.data?.order_creation_config?.upload_orders
          ?.product_selection
      );
      setFetchingOrdersFromERPOption(
        settingsData?.data?.order_creation_config?.erp_orders?.product_selection
      );
      setDummyOrdersOption(
        settingsData?.data?.order_creation_config?.dummy_orders
          ?.product_selection
      );
      setData(settingsData?.data?.order_creation_config);
    }
  }, []);

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2000);
  };

  useEffect(()=>{
    if(isDataUpdated && !isVisibleOrderCreationConfigDrawer)
    {
      showToaster();
      setDataUpdated(false);
    }
  },[isDataUpdated,isVisibleOrderCreationConfigDrawer])

  const handleToggleChange = async (type, e) => {
    setDummyOrdersOption(e.target.value);
    let reqBody = data;
    reqBody[type]["product_selection"] = e.target.value;
    console.log(reqBody);
    try {
      let resp = await updateOrderCreationConfig(reqBody);
      if (!resp?.error) {
        setActionToaster({
          error: resp?.error,
          msg: resp?.msg,
        });
        showToaster();
      }
      // setRendering(true);
    } catch (err) {
      setActionToaster({
        error: err?.error,
        msg: err?.response?.msg,
      });
      showToaster();
    }
  };

  const onOrderSettingClicked = (order_type) => {
    setCategoryType(order_type);
    setVisibleOrderCreationConfigDrawer(true);
  };

  return data ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader ghost={false} title={"Order Creation Config"} />
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              //   onFinish={onFinish}
            >
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Orders</h2>
                    <p>Selected fields will appear while creating orders</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Product selection</label>
                        <p>Selection style for products</p>
                      </div>
                    </Col>
                    <Col span={dummy_ordersOption == "specs" ? 10 : 12}>
                      <div
                        className="boxFormType switchRadio toggleClassOrderCreation"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Form.Item
                          name="orders"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          initialValue={ordersOption}
                        >
                          <Radio.Group
                            options={toggleOptions}
                            value={ordersOption}
                            optionType="button"
                            buttonStyle="solid"
                            disabled
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Uploading Orders</h2>
                    <p>Selected fields will appear while uploading orders</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Product selection</label>
                        <p>Selection style for products</p>
                      </div>
                    </Col>
                    <Col span={dummy_ordersOption == "specs" ? 10 : 12}>
                      <div
                        className="boxFormType switchRadio toggleClassOrderCreation"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Form.Item
                          name="uploading_orders"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          initialValue={uploading_ordersOption}
                        >
                          <Radio.Group
                            options={toggleOptions}
                            value={uploading_ordersOption}
                            optionType="button"
                            buttonStyle="solid"
                            disabled
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    {dummy_ordersOption == "specs" ? (
                      <Col span={2}>
                      <div className="boxFormType" style={{ justifyContent: "flex-end", display: "flex" }}>
                              <Button
                                key="3"
                                className="textTypeBtn edit-btn"
                                onClick={()=>onOrderSettingClicked("upload_orders")}
                              >
                                <Iconmoon
                                  icon={"setting"}
                                  size={16}
                                  color="#605E5C"
                                />
                              </Button>
                      </div>
                    </Col>) : null}
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Fetching Orders from ERP</h2>
                    <p>
                      Selected fields will appear while fetching orders from ERP
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Product selection</label>
                        <p>Selection style for products</p>
                      </div>
                    </Col>
                    <Col span={dummy_ordersOption == "specs" ? 10 : 12}>
                      <div
                        className="boxFormType switchRadio toggleClassOrderCreation"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Form.Item
                          name="fetching_orders_from_ERP"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          initialValue={fetchingOrdersFromERP_option}
                        >
                          <Radio.Group
                            options={toggleOptions}
                            value={fetchingOrdersFromERP_option}
                            optionType="button"
                            buttonStyle="solid"
                            disabled
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Dummy Orders</h2>
                    <p>Selected fields will appear while creating dummy orders</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Product selection</label>
                        <p>Selection style for products</p>
                      </div>
                    </Col>
                    <Col span={dummy_ordersOption == "specs" ? 10 : 12}>
                      <div
                        className="boxFormType switchRadio toggleClassOrderCreation"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Form.Item
                          name="dummy_orders"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          initialValue={dummy_ordersOption}
                        >
                          <Radio.Group
                            options={toggleOptions}
                            value={dummy_ordersOption}
                            onChange={(e) => {
                              handleToggleChange("dummy_orders", e);
                            }}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    {dummy_ordersOption == "specs" ? (
                      <Col span={2}>
                      <div className="boxFormType" style={{ justifyContent: "flex-end", display: "flex" }}>
                              <Button
                                key="3"
                                className="textTypeBtn edit-btn"
                                onClick={()=>onOrderSettingClicked("dummy_orders")}
                              >
                                <Iconmoon
                                  icon={"setting"}
                                  size={16}
                                  color="#605E5C"
                                />
                              </Button>
                      </div>
                    </Col>) : null}
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}
      {isVisibleOrderCreationConfigDrawer && <OrderCreationConfigSettingDrawer
          visible={isVisibleOrderCreationConfigDrawer}
          setVisibleOrderCreationConfigDrawer={setVisibleOrderCreationConfigDrawer}
          orderType={categoryType}
          setActionToaster={setActionToaster}
          setDataUpdated={setDataUpdated}
      />}
    </RightLayoutContainer>
  ) : null;
};
export default OrderCreationConfig;
